export const makeNavigateNextProps = ({
  paginatedQuestionsListManager,
  activeQuestionSet: questionSet,
  activeQuestion: question,
  setActiveQuestionState,
  scrollToQuestionByIdFunc
}) => {
  const currentQuestionSets = paginatedQuestionsListManager.getResults();
  if (currentQuestionSets.isEmpty()) {
    return makeNavigateProps(null);
  }
  const nextSetAndQuestion = getNextQuestionState({
    questionSets: currentQuestionSets,
    activeSet: questionSet,
    activeQuestion: question
  });
  return makeNavigateProps(nextSetAndQuestion, setActiveQuestionState, scrollToQuestionByIdFunc);
};

export const makeNavigateBackProps = ({
  paginatedQuestionsListManager,
  activeQuestionSet: questionSet,
  activeQuestion: question,
  setActiveQuestionState,
  scrollToQuestionByIdFunc
}) => {
  const currentQuestionSets = paginatedQuestionsListManager.getResults();
  if (currentQuestionSets.isEmpty()) {
    return makeNavigateProps(null);
  }

  const previousSetAndQuestion = getPreviousQuestionState({
    questionSets: currentQuestionSets,
    activeSet: questionSet,
    activeQuestion: question
  });
  return makeNavigateProps(
    previousSetAndQuestion,
    setActiveQuestionState,
    scrollToQuestionByIdFunc
  );
};

export const makeNavigateProps = (
  upcomingSetAndQuestion,
  setActiveQuestionState,
  scrollToQuestionByIdFunc
) => {
  if (!upcomingSetAndQuestion) {
    return {disabled: true, handleNavigation: undefined};
  }
  const {questionSet, question} = upcomingSetAndQuestion;
  return {
    disabled: false,
    handleNavigation: () => {
      scrollToQuestionByIdFunc.current(questionSet.getId());
      setActiveQuestionState(question, questionSet);
    }
  };
};

export function getPreviousQuestionState({questionSets, activeSet, activeQuestion}) {
  if (!activeSet || !activeQuestion) {
    return null;
  }
  const currentQuestionSetPos = questionSets.findIndex((set) => set.getId() === activeSet.getId());

  if (!currentQuestionSetPos || currentQuestionSetPos === 0) {
    return null;
  }

  const previousQuestionSet = questionSets.get(currentQuestionSetPos - 1);

  return {
    questionSet: previousQuestionSet,
    question: previousQuestionSet.getQuestions().first()
  };
}

export function getNextQuestionState({questionSets, activeSet, activeQuestion}) {
  if (!activeSet || !activeQuestion) {
    return null;
  }
  const currentQuestionSetPos = questionSets.findIndex((set) => set.getId() === activeSet.getId());
  const totalQuestionSets = questionSets.size;

  if (
    (currentQuestionSetPos !== 0 && !currentQuestionSetPos) ||
    currentQuestionSetPos === totalQuestionSets - 1
  ) {
    return null;
  }

  const nextSet = questionSets.get(currentQuestionSetPos + 1);

  return {
    questionSet: nextSet,
    question: nextSet.getQuestions().first()
  };
}
